import * as Yup from 'yup'

export const HR_TAG_PATH = '/hr/tag'

/** TagDto */
export interface ITagModel {
  id: string
  name: string
  /** #RRGGBB */
  color: string
  createdBy?: string
  createdDate?: string
  /** Yalnızca etiket ekranında dolu */
  candidateCount?: number | null
}

export interface ITagRequest {
  name: string
  color: string
}

/** Hızlı seçim paleti; renk seçiciyle farklı bir renk de seçilebilir */
export const TAG_COLORS = [
  '#f1416c',
  '#ffc700',
  '#50cd89',
  '#009ef7',
  '#7239ea',
  '#3f4254',
  '#ff8a00',
  '#00b2a9',
]

export const initialTagForm: ITagRequest = {name: '', color: TAG_COLORS[3]}

export const validationTag = Yup.object().shape({
  name: Yup.string().trim().required('Etiket adı zorunludur').max(50, 'En fazla 50 karakter'),
  color: Yup.string()
    .required('Renk seçiniz')
    .matches(/^#[0-9a-fA-F]{6}$/, 'Geçerli bir renk seçiniz'),
})

/** Etiket rengi üzerinde okunabilir yazı rengi (açık zeminde koyu, koyu zeminde beyaz) */
export const tagTextColor = (hex: string) => {
  const value = hex.replace('#', '')
  const r = parseInt(value.substring(0, 2), 16)
  const g = parseInt(value.substring(2, 4), 16)
  const b = parseInt(value.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? '#181c32' : '#ffffff'
}
